export default __webpack_public_path__ + "static/media/FrontWall.ead950a7.glb";